import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid2,
  Paper,
} from "@mui/material";
import * as React from "react";
import banner from "../images/image001.png";
import logo from "../images/logo_DLS2.png";
import Typography from "@mui/material/Typography";
import Tabla from "../components/Tabla";
import Niveles from "../components/Niveles";
import { Helmet } from "react-helmet-async";

function Cursos() {
  return (
    <>
      <Helmet>
        <title> DLS - Cursos</title>

        <meta
          name="description"
          content="DLS cuenta con dos versiones del examen diagnóstico que pueden ser fácilmente administrados en su institución, hogar o en nuestro centro de idiomas, la escala que nos ayuda a determinar el nivel es la “Escala de porcentajes del examen TOEFL iBT”."
        />
        <meta
          name="keywords"
          content="direccion, bolivia, La Paz, Cochabamba, Santa Cruz, examen, curso, evaluacion, diagnostico, examen TOEFL iBT"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Cursos de ingles y preparacion" />
        <meta
          property="og:description"
          content="DLS cuenta con dos versiones del examen diagnóstico que pueden ser fácilmente administrados en su institución, hogar o en nuestro centro de idiomas, la escala que nos ayuda a determinar el nivel es la “Escala de porcentajes del examen TOEFL iBT."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta property="og:url" content="http://localhost:3000/#/cursos" />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <Box
        sx={{
          width: "auto",
          display: "block",
          textAlign: "justify",
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={banner}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "15px",
                    }}
                  >
                    <Box
                      color="secondary"
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "center",
                        color: "#009999",
                      }}
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          display: "inline",
                          fontSize: {
                            xs: "20px",
                            sm: "32px",
                            md: "22px",
                            lg: "28px",
                          },
                        }}
                      >
                        <b>
                          CURSOS DE INGLÉS
                          <br /> PARA ALUMNOS DE 12 AÑOS O MAS
                        </b>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            width: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "2px",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "98vw",
                sm: "90vw",
                md: "70vw",
              },
              display: "block",
              padding: "2px",
            }}
          >
            <Box p={3}>
              <Box sx={{ paddingRight: "10px" }}>
                <Typography variant="h5">
                  <b>¿Que es el Examen Diagnostico?</b>
                </Typography>
                <Typography variant="h6">
                  <ul>
                    <li>
                      Es el primer paso que nos ayudará a determinar el nivel de
                      conocimiento del idioma de cada uno de los postulantes.
                      DLS cuenta con dos versiones del examen diagnóstico que
                      pueden ser fácilmente administrados en su institución,
                      hogar o en nuestro centro de idiomas, la escala que nos
                      ayuda a determinar el nivel es la “Escala de porcentajes
                      del examen TOEFL iBT”:
                    </li>
                  </ul>
                </Typography>
              </Box>
            </Box>

            <Box>
              <Tabla />
            </Box>
            <Box sx={{ padding: "20px 0" }}>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        <b> OBJETIVOS DEL CURSO</b>
                      </Typography>
                      <Typography variant="body2" sx={{ lineHeight: "1.5" }}>
                        <ul>
                          <li>
                            Desarrollar cuatro habilidades: leer, escribir,
                            escuchar y hablar en inglés americano.
                          </li>
                          <li>
                            Desarrollar el conocimiento y la aplicación de las
                            estructuras gramaticales.
                          </li>
                          <li>
                            Facilitar la terminología "especializada o técnica"
                            si el alumno así lo requiriese.
                          </li>
                        </ul>
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        <b> ALCANCE</b>
                      </Typography>
                      <Typography>
                        <b>
                          {" "}
                          El estudiante al finalizar el programa de capacitación
                        </b>
                        podrá:
                      </Typography>
                      <Typography variant="body2">
                        <ul>
                          <li>
                            Entender y expresarse oralmente a un nivel óptimo,
                            pudiendo mantener una conversación óptima y fluida.
                          </li>
                          <li>
                            Traducir e interpretar documentos y materiales del
                            inglés al español a un nivel óptimo.
                          </li>
                          <li>
                            Escribir fácilmente cartas, e-mails y otros
                            documentos de requerimiento cotidiano.
                          </li>
                        </ul>
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid2>
              </Grid2>
            </Box>
            <hr />
            <Box sx={{ padding: "20px 0" }}>
              <Typography variant="h5">
                <b>NIVELES Y ALCANCES DEL CURSO</b>
              </Typography>
            </Box>
            <Box
              sx={{
                textAlign: "center",
                paddingBottom: "25px",
              }}
            ></Box>
            <Box>
              <Niveles />
            </Box>
            <Box sx={{ padding: "20px 0" }}>
              <Typography variant="h5">
                <b>CURSOS ADICIONALES</b>
              </Typography>
            </Box>
            <Box sx={{ border: "1px solid #009999" }}>
              <Box
                sx={{
                  background: "#009999",
                  color: "#fff",
                  textAlign: "center",
                  padding: "10px 0",
                }}
              >
                <Typography>
                  <b> CLASES DE APOYO GRAMATICAL</b>
                </Typography>
              </Box>
              <Box sx={{ padding: "3px 20px" }}>
                <p>
                  Dependiendo de los resultados del examen diagnóstico, y con
                  respecto al puntaje específico en las áreas de escritura,
                  audición, conversación o lectura, proponemos desarrollar
                  cursos específicos dirigidos a las necesidades de cada
                  estudiante: clases especiales de revisión de gramática y/o de
                  reforzamiento.
                </p>
              </Box>
            </Box>
            <Box sx={{ border: "1px solid #009999" }}>
              <Box
                sx={{
                  background: "#009999",
                  color: "#fff",
                  textAlign: "center",
                  padding: "10px 0",
                }}
              >
                <Typography>
                  <b> CLASES DE CONVERSACIÓN</b>
                </Typography>
              </Box>
              <Box sx={{ padding: "3px 20px" }}>
                <p>
                  El requisito para acceder a este curso es alcanzar un puntaje
                  mínimo de 75 puntos sobre 120 en nuestro examen de diagnóstico
                  de nivel.
                </p>
              </Box>
            </Box>
            <Box sx={{ border: "1px solid #009999" }}>
              <Box
                sx={{
                  background: "#009999",
                  color: "#fff",
                  textAlign: "center",
                  padding: "10px 0",
                }}
              >
                <Typography>
                  <b> CLUB DE LECTURA</b>
                </Typography>
              </Box>
              <Box sx={{ padding: "3px 20px" }}>
                <p>
                  El requisito para acceder a este curso es alcanzar un puntaje
                  mínimo de 75 puntos sobre 120 en nuestro examen de diagnóstico
                  de nivel.
                </p>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Cursos;
